<h2 mat-dialog-title class="dialog-title">Events am {{ formatDay(data.date) }}</h2>
<p class="dialog-subtitle">{{ formatDateOnly(data.date) }}</p>
<div class="dialog-subtitle-divider"></div>

<mat-dialog-content class="events-dialog-content">
  <div class="events-list" *ngIf="data.events.length > 0; else noEvents">
    <mat-card
      class="event-card"
      [style.border-color]="getTypeColor(event.type)"
      *ngFor="let event of data.events">
      <div class="event-card-top" [class.event-card-top-single]="event.location && !data.canEdit && !data.canDelete && !data.canManageParticipants && !data.canViewStatistics">
        <div class="event-main">
          <div class="event-title">{{ event.name }}</div>
          <div class="event-time">{{ formatShortDate(asDate(event.start)) }} {{ formatTime(asDate(event.start)) }} - {{ formatShortDate(asDate(event.end)) }} {{ formatTime(asDate(event.end)) }}</div>
          <div class="event-location" *ngIf="event.location">
            <mat-icon class="event-location-icon">location_on</mat-icon>
            <span>{{ event.location }}</span>
          </div>
        </div>
        <div class="event-actions" [class.event-actions-single]="event.location && !data.canEdit && !data.canDelete && !data.canManageParticipants && !data.canViewStatistics">
          <div class="event-actions-divider" *ngIf="event.location || data.canEdit || data.canDelete || data.canManageParticipants || data.canViewStatistics"></div>
          <button *ngIf="event.location" mat-icon-button color="primary" aria-label="Navigation öffnen" (click)="openNavigation(event.location, $event)">
            <mat-icon>navigation</mat-icon>
          </button>
          <button *ngIf="data.canViewStatistics" mat-icon-button color="primary" aria-label="Statistik anzeigen" (click)="onViewStatistics(event)">
            <mat-icon>bar_chart</mat-icon>
          </button>
          <button *ngIf="data.canManageParticipants" mat-icon-button color="primary" aria-label="Teilnehmer verwalten" (click)="onManageParticipants(event)">
            <mat-icon>people</mat-icon>
          </button>
          <button *ngIf="data.canEdit" mat-icon-button color="primary" aria-label="Event bearbeiten" (click)="onEdit(event)">
            <mat-icon>edit</mat-icon>
          </button>
          <button *ngIf="data.canDelete" mat-icon-button color="warn" aria-label="Event löschen" (click)="onDelete(event)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <!-- Registration section -->
      <div class="event-registration" *ngIf="canRegister() && !isEventPast(event)">
        <div class="event-registration-divider"></div>
        <div class="event-registration-content">
          <!-- Loading state -->
          <div *ngIf="getRegistrationState(event).loading" class="registration-loading">
            <mat-icon class="registration-spinner">hourglass_empty</mat-icon>
            <span class="registration-loading-text">Lade...</span>
          </div>

          <!-- Register button -->
          <button
            *ngIf="!getRegistrationState(event).loading && !getRegistrationState(event).registered"
            mat-raised-button
            color="primary"
            class="registration-btn register-btn"
            [disabled]="getRegistrationState(event).processing"
            (click)="onRegister(event)">
            <mat-icon>how_to_reg</mat-icon>
            <span class="registration-btn-label">
              {{ getRegistrationState(event).processing ? 'Wird angemeldet...' : 'Anmelden' }}
            </span>
          </button>

          <!-- Unregister button -->
          <button
            *ngIf="!getRegistrationState(event).loading && getRegistrationState(event).registered"
            mat-stroked-button
            color="warn"
            class="registration-btn unregister-btn"
            [disabled]="getRegistrationState(event).processing"
            (click)="onUnregister(event)">
            <mat-icon>person_remove</mat-icon>
            <span class="registration-btn-label">
              {{ getRegistrationState(event).processing ? 'Wird abgemeldet...' : 'Abmelden' }}
            </span>
          </button>
        </div>
      </div>
    </mat-card>
  </div>

  <ng-template #noEvents>
    <p class="empty-state">Keine Events für diesen Tag.</p>
  </ng-template>
</mat-dialog-content>

<div class="dialog-list-divider"></div>

<mat-dialog-actions align="end" class="dialog-actions" [class.single-action]="!data.canCreate">
  <button *ngIf="data.canCreate" mat-raised-button color="primary" class="dialog-btn dialog-btn-create" (click)="onCreate()">
    <mat-icon>add</mat-icon>
    <span class="dialog-btn-label">Erstellen</span>
  </button>
  <button mat-stroked-button color="warn" class="dialog-btn dialog-btn-close" (click)="onClose()">
    <mat-icon>close</mat-icon>
    <span class="dialog-btn-label">Schließen</span>
  </button>
</mat-dialog-actions>
